<div [class.has-error]="showError && !!formControl.errors" class="form-group {{ props.fieldGroupClassName }}">
  <label *ngIf="props.label && props.hideLabel !== true" [className]="props.labelClassName" [for]="id">
    <span [innerHTML]="props.label"></span>
    <span *ngIf="props.required && !props.hideRequiredMarker" class="required-marker">
      {{ props.requiredMarker || "*" }}
    </span>
    <span *ngIf="!props.required && !props.hideOptionalMarker" class="optional-marker">
      {{ "(optional)" | translate }}
    </span>
  </label>

  <ng-container #fieldComponent></ng-container>

  <astrobin-subject-type-suggestion-pill
    *ngIf="showSuggestion"
    [isSolarSystemSubject]="true"
    [loading]="false"
    [suggestion]="suggestionState?.suggestion"
    (apply)="imageEditPageComponent.onApplySolarSystemSuggestion($event)"
    (dismiss)="imageEditPageComponent.onDismissSolarSystemSuggestion()"
  >
  </astrobin-subject-type-suggestion-pill>

  <div *ngIf="showError" [style.display]="'block'" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>

  <small *ngIf="props.description" [innerHTML]="props.description" class="form-text text-muted"></small>

  <!-- Auto-applied suggestion info -->
  <div *ngIf="showAutoAppliedInfo" class="auto-applied-info">
    <astrobin-sparkles-icon [height]="12" [width]="12"></astrobin-sparkles-icon>
    <span>{{ "Auto-filled with high confidence. Change if needed." | translate }}</span>
    <button
      [attr.aria-label]="'Dismiss' | translate"
      (click)="imageEditPageComponent.onDismissSolarSystemSuggestion()"
      class="btn btn-link btn-sm btn-no-block dismiss-info-btn"
      type="button"
    >
      <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </button>
  </div>
</div>
